import ColumnModel from '@/components/layout/column/ColumnModel';
import { SdkBaseAddonModel } from './addons';
import { SdkAddonRegistration } from './addons/registration';

export class SdkColumnModel {
  #model: ColumnModel;

  constructor(model: ColumnModel) {
    this.#model = model;
  }

  public get addons() {
    return this.#model.state.addons.map<SdkAddonRegistration | SdkBaseAddonModel>((addon) => {
      if (addon.alias === 'registration') {
        return new SdkAddonRegistration(addon);
      }

      return new SdkBaseAddonModel(addon);
    });
  }

  public get id(): string {
    return this.#model.state.id;
  }

  public get label(): string {
    return this.#model.state.label;
  }
}
